import { useEffect, useState } from 'react';

const ATB_CAROUSEL_SELECTOR = '[data-testid="recommendations-carousel-add-to-basket"]';
const ATB_CAROUSEL_POLL_INTERVAL_MS = 500;
const ATB_CAROUSEL_POLL_TIMEOUT_MS = 15000;

export function useATBRecs(recsAtbRef: React.Ref<HTMLDivElement> | undefined, enabled = true): boolean {
  const [hasCarousel, setHasCarousel] = useState(false);

  useEffect(() => {
    if (!enabled) return;
    const esiNode = document.getElementById('esi-recs-atb');
    if (esiNode && recsAtbRef && 'current' in recsAtbRef && recsAtbRef.current) {
      recsAtbRef.current.appendChild(esiNode);
      esiNode.hidden = false;
    }
  }, []);

  useEffect(() => {
    if (!enabled) return undefined;
    const interval = setInterval(() => {
      if (document.querySelector(ATB_CAROUSEL_SELECTOR)) {
        setHasCarousel(true);
        clearInterval(interval);
      }
    }, ATB_CAROUSEL_POLL_INTERVAL_MS);

    const timeout = setTimeout(() => clearInterval(interval), ATB_CAROUSEL_POLL_TIMEOUT_MS);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, []);

  return hasCarousel;
}
